import { useNavigate } from '@tanstack/react-router';
import { authApi } from '@/api/endpoints/auth';
import { forgetMoneyWritesInMemory } from '@/lib/writeDoubt';
import { useAuthStore } from '@/stores/authStore';

/**
 * Cierra la sesión en el back (sin bloquear si falla), limpia el perfil y las llaves de dinero en
 * memoria y lleva a /login. Las dudas guardadas en el navegador se quedan: protegen al recurso.
 */
export function useLogout(): () => Promise<void> {
    const navigate = useNavigate();
    const user = useAuthStore((s) => s.user);
    const clear = useAuthStore((s) => s.clear);
    return async () => {
        if (user) {
            await authApi
                .logout({ cognitoSub: user.cognitoSub, tenantId: user.tenantId })
                .catch(() => undefined);
        }
        clear();
        forgetMoneyWritesInMemory();
        await navigate({ to: '/login' });
    };
}
